<template>
  <el-dialog
    :visible.sync="show"
    custom-class="signupDialog"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    >
    <div class="first-floor">
      <div class="label">
        <span class="title required">用户类型：</span>
        <div class="radioBox">
          <el-radio v-model="form.user_type" :label="1">设计师</el-radio>
          <el-radio v-model="form.user_type" :label="3">装修经理</el-radio>
        </div>
      </div>
      
    </div>
    <div class="first-floor" v-if="form.user_type == 1">
      <div class="label">
        <span class="title required">选择礼物：</span>
        <div class="radioBox" @change="changeGift">
          <el-radio v-model="form.gift_name" label="设计师定制工具包">设计师定制工具包</el-radio>
          <el-radio v-model="form.gift_name" label="三棵树新款POLO衫">三棵树新款POLO衫</el-radio>
          <el-radio v-model="form.gift_name" label="大圣可刻字保温杯礼盒">大圣可刻字保温杯礼盒</el-radio>
        </div>
      </div>
    </div>
    <div class="first-floor" v-if="form.user_type == 1 && form.gift_name == '大圣可刻字保温杯礼盒'">
      <div class="label">
        <el-input v-model="form.gift_desc" maxLength="6" placeholder="请输入礼品刻字内容，最多可输入6个字符"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">案例名称：</span>
        <el-input v-model="form.creation_name" placeholder="请输入案例名称"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">案例地点：</span>
        <el-cascader
          class="selectInput"
					v-model="cityData"
					:options="cityList"
					popper-class="popperinp2"
          @change="selectedCity"
        >
        </el-cascader>
      </div>
      <div class="label">
        <span class="title required">建筑面积：</span>
        <el-input v-model="form.area" type="tel" placeholder="请输入建筑面积" @input="formatteInput"></el-input>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">使用产品：</span>
        <el-select v-model="form.products[0].product" placeholder="请选择" popper-class="popperinp2">
					<el-option
						v-for="item in productList"
						:key="item.prod"
						:label="item.prod"
						:value="item.prod">
					</el-option>
				</el-select>
      </div>
      <div class="label">
        <span class="title required">产品花色：</span>
        <el-select v-model="form.products[0].model" placeholder="请选择" popper-class="popperinp2" :disabled="!form.products[0].product" @focus="changeColorList">
					<el-option
						v-for="(item, index) in colorList"
						:key="item + index"
						:label="item"
						:value="item">
					</el-option>
				</el-select>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <span class="title required">案例描述：</span>
        <el-input
          type="textarea"
          :rows="6"
          placeholder="请输入设计理念及小森花色选择 "
          resize="none"
          v-model="form.comment">
        </el-input>
      </div>
    </div>
    <div class="first-floor anotherfloor">
      <div class="label anotherlabel">
        <span class="title required">封面图片(请提供方形图片，图片大小不超过5M)</span>
        <div class="image-box">
          <el-upload
            class="visiting-card-uploader"
            action="#"
            :show-file-list="false"
            :http-request="afterReadtitle">
            <img v-if="form.title_pic" :src="form.title_pic" class="card">
            <img v-else class="card-default" src="@/assets/serve/designer/camera-icon.png">
          </el-upload>
        </div>
      </div>
    </div>
    <div class="first-floor anotherfloor">
      <div class="label anotherlabel">
        <span class="title required">案例图片(图片大小不超过5M)</span>
        <div class="image-box">
          <template v-for="(item, index) in form.photos">
            <div v-if="form.photos.length > 0" class="img-content" :key="index">
              <img :src="item.pic_url" class="card" :key="index" >
              <img class="close-icon" src="@/assets/serve/designer/close-icon.png" alt="" srcset="" @click="deleteImg(index)">
            </div>
          </template>
          <el-upload
            class="visiting-card-uploader"
            action="#"
            :show-file-list="false"
            :http-request="afterReadPhoto">
            <img class="card-default" src="@/assets/serve/designer/camera-icon.png">
          </el-upload>
        </div>
      </div>
    </div>
    <el-button class="signupBtn" type="success" :loading="isloading" @click="submitForm">{{isloading ? '提交中...' : '提交'}}</el-button>
  </el-dialog>
</template>

<script>
import { upload, productList } from '@/api/tools.js'
import { addCase, updateCase } from '@/api/case.js'
import '@/util/area'
export default {
  name: 'designerSignup',
  components:{ 
  },
  props: {
    userInfo: {}, 
    show: false,
    info: null,
  },
  data() {
    return {
      isloading: false,
      form: {
        user_type: this.userInfo.user_type || null,
        creation_name: '', // 案例名称
        province: '', // 省
        city: '', // 市
        area: '', // 建筑面积
        // 使用产品 产品花色
        products: [
          {
            product: '',
            model: ''
          }
        ],
        // 封面图片上传
        title_pic: '',
        photos: [],
        comment: '',
        gift_name: '',
        gift_desc: ''
      },
      productData: '',
      modelData: '',
      cityData: [],
      productList: [],
      colorList: [],
      cityList: [],
      isClickSignup: false
    }
  },
  computed:{ },
  watch: {
  },
  created() {
    // 回显
    this.getCity()
    this.getproductList()
    if (this.info) {
      this.form = {...this.form, ...this.info}
      this.form.photos = JSON.parse(this.form.photos)
      this.form.products = JSON.parse(this.form.products)
      const data = this.form
      const obj = this.cityList.filter(item => item.label === data.province)[0]
      console.log('obj', obj)
      const value1 = obj.value
      let value2
      let obj1
      obj1 = obj.children.filter(item => item.label === data.city)[0]
      value2 = obj1.value
      this.cityData[0] = value1
      this.cityData[1] = value2
    }
  },
  mounted() {
  },
  methods: {
    formatteInput(value) {
      this.form.area = value.replace(/[^\d.]/,'').replace(/\.\d{2,}$/, value.substr(value.indexOf('.'), 3))
    },
    changeGift() {
      this.form.gift_desc = ''
    },
    getproductList() {
      productList().then((res) => {
        this.productList = res
      })
    },
    changeColorList() {
      console.log(this.productList.filter(item => item.prod === this.form.products[0].product)[0])
      this.colorList = this.productList.filter(item => item.prod === this.form.products[0].product)[0].colList || []
    },
    getCity() {
      const allCityInformation = city()
      this.cityList = this.traverse(86, allCityInformation)
      this.cityList.map(item => {
        item.children.map(secondItem => {
          delete secondItem.children
          return secondItem
        })
        return item
      })
    },
		traverse(key, obj) {
      const objes = obj[key]
      const arr = []
      for (const i in objes) {
        arr.push({
          label: objes[i],
          value: i,
          children: obj[i] && this.traverse(i, obj)
        })
      }
      return arr
    },

    selectedCity(val) {
      console.log('selectedCity', val)
      this.cityList.filter(item => val[0])[0]
      this.form.province = this.cityList.filter(item => item.value === val[0])[0].label
      this.form.city = this.cityList.filter(item => item.value === val[0])[0].children.filter(seconditem => seconditem.value === val[1])[0].label
    },

    // 上传封面
    afterReadtitle(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          this.form.title_pic = res.fileLink
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },

    // 上传案例
    afterReadPhoto(file) {
      upload(file.file).then((res) => {
        if (res.result === 1) {
          const obj = {
            pic_url: res.fileLink,
            url: res.fileLink,
          }
          this.form.photos.push(obj)
        } else {
          this.$message(res.msg)
        }
      }).catch((err) => console.log(err))
    },

    deleteImg(index) {
      this.form.photos.splice(index, 1)
    },

    submitForm() {
      this.isloading = true
      if (this.isClickSignup) return
      this.isClickSignup = true
      if (this.form.user_type == '') {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请选择类型')
        return
      }
      if (!this.form.creation_name) {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请输入案件名称')
        return
      }
      if (!this.form.province && !this.form.city)  {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请选择案件地点')
        return
      }
      if (!this.form.area) {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请输入建筑面积')
        return
      }
      if (this.form.products[0].product === '')  {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请选择使用产品')
        return
      }
      if (this.form.products[0].model === '')  {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请选择产品花色')
        return
      }
      if (!this.form.comment) {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请输入案件描述')
        return
      }
      if (!this.form.title_pic) {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请上传封面图片')
        return
      }
      if (this.form.photos.length <=0 ) {
        this.isClickSignup = false
        this.isloading = false
        this.$message('请上传案例图片')
        return
      }
      if (this.form.user_type == 1 && this.form.gift_name === '大圣可刻字保温杯礼盒' && this.form.gift_desc === '') {
        this.isClickRegister = false
        this.$message('请输入刻字内容')
        return
      }
      if (this.form.user_type == 1 && this.form.gift_name === '') {
        this.isClickRegister = false
        this.$message('请选择礼物')
        return
      }
      if (this.info) {
        this.form.creation_id = this.form.id
        updateCase({...this.form}).then(res => {
          if (res.result === 1) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.isloading = false
            this.isClickSignup = false
            this.$emit('refresh')
            this.$emit('close', false)
          } else {
            this.isloading = false
            this.$message(res.msg)
            this.isClickSignup = false
          }
        })
      } else {
        addCase({...this.form}).then(res => {
          if (res.result === 1) {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            this.isloading = false
            this.isClickSignup = false
            this.$emit('refresh')
            this.$emit('close', false)
            this.$emit('success', true)
          } else {
            this.isloading = false
            this.$message(res.msg)
            this.isClickSignup = false
          }
        })
      }
    },
    closeDialog() {
      this.form = {
        user_type: this.userInfo.user_type || null,
        creation_name: '', // 案例名称
        province: '', // 省
        city: '', // 市
        area: '', // 建筑面积
        // 使用产品 产品花色
        products: [
          {
            product: '',
            model: ''
          }
        ],
        // 封面图片上传
        title_pic: '',
        photos: [],
        comment: ''
      },
      this.$emit('refresh')
      this.$emit('close', false)
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog.signupDialog {
  width: 1334px!important;
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 70px 80px 80px 80px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    position: relative;
    .first-floor {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      .label {
        flex: 1;
        padding: 0 10px;
        border-radius: 26px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .title {
          height: 50px;
          line-height: 50px;
          white-space: nowrap;
          text-align: left;
          font-size: 24px;
          font-family: FZLanTingHeiS-DB-GB;
          font-weight: 400;
          margin-bottom: 15px;
          &.required {
            position: relative;
            &::before {
              content: '*';
              position: absolute;
              top: 2px;
              left: -15px;
              color: #E83636;
            }
          }
        }
        &:nth-of-type(2) {
          margin-left: 20px;
        }
        .mobilecode {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border: 1px solid #B8D4B4;
          border-radius: 26px;
          .el-input__inner {
            border: 0;
          }
        }
        .radioBox {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .el-radio {
            display: flex;
            align-items: center;
          }
          .el-radio__label {
            font-size: 24px;
            font-family: FZLanTingHeiS-DB-GB;
            font-weight: 400;
            color: #666666;
          }
        }
        .el-radio__input {
          width: 29px;
          height: 29px;
          .el-radio__inner {
            width: 100%;
            height: 100%;
          }
          &.is-checked {
            &+.el-radio__label {
              color: #4E8B46;
            }
            .el-radio__inner {
              background: #4E8B46;
              border-color: #4E8B46;
              &:after {
                width: 100%;
                height: 100%;
                content: '\2714';
                font-size: 30px;
                color: #fff;
                background-color: #4E8B46;
              }
            }
          }
        }
        .el-cascader, .el-select, .el-input {
          width: 100%;
          input {
            background: #F5F8F4;
          }
        }
        .el-textarea {
          textarea {
            border: 2px solid #B8D4B4;
            border-radius: 32px;
            font-size: 24px;
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            color: #999999;
          }
        }
        .el-input__inner {
          width: 100%;
          outline: none;
          font-size: 24px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #000;
          border: 1px solid #B8D4B4;
          border-radius: 26px;
          &::placeholder {
            font-size: 24px;
          }
        }
        .codeBtn {
          width: 160px;
          height: 44px;
          background: #4E8B46;
          border: 1px solid #4E8B46;
          border-radius: 22px;
          color: #fff;
          margin-right: -7px;
          font-size: 16px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          :hover {
            color: #fff;
          }
          &.is-disabled {
            background: #ccc;
            border-color: #ccc;
          }
        }
        .image-box {
          display: flex;
          justify-content: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          .img-content {
            width: 247px;
            height: 247px;
            border-radius: 9px;
            margin-right: 20px;
            margin-bottom: 20px;
            position: relative;
            .close-icon {
              width: 38px;
              height: 38px;
              position: absolute;
              top: -11px;
              right: -9PX;
              cursor: pointer;
            }
          }
          .card {
            display: flex;
            flex-direction: row;
            width: 247px;
            height: 247px;
            border-radius: 9px;
            margin-right: 20px;
            margin-bottom: 20px;
          }
        }
        .visiting-card-uploader {
          width: 247px;
          height: 247px;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-upload {
            width: 100%;
            height: 100%;
            display: flex;
            border-radius: 9px;
            background: #F2F2F2;
            overflow: hidden;
            text-align: center;
            position: relative;
            .card {
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
              vertical-align: middle;
            }
            .card-default {
              width: 86px;
              height: 74px;
              object-fit: cover;
              vertical-align: middle;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        &.anotherlabel {
          height: auto;
          align-items: flex-start;
        }
      }
      &.anotherfloor {
        align-items: flex-start;
      }
    }
    .signupBtn {
      width: 100%;
      height: 97px;
      background: #4E8B46;
      border-radius: 32px 32px 32px 32px;
      font-size: 45px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #FFFFFF;
      margin: 80px auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      -webkit-user-select: none;
      .el-icon-loading {
        font-size: 45px!important;
      } 
    }
  }
}
</style>
<style lang='less'>
.el-scrollbar .el-select-dropdown__item  {
  font-size: 20px;
}
.el-cascader-panel .el-cascader-node__label {
  font-size: 20px;
}
</style>